export default "__VITE_ASSET__DX$Wwo4p__"